import { render, staticRenderFns } from "./Declaration_vh_fc.vue?vue&type=template&id=46f18a3e"
import script from "./Declaration_vh_fc.vue?vue&type=script&lang=js"
export * from "./Declaration_vh_fc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports